import type { IAsset } from './assets';
import type { ISchemaContainer } from './schemaContainer';
import { asset } from './assets';

export const analysisReportAssetSchema: ISchemaContainer<IAsset> = {
    schema: asset.options({ convert: false, presence: 'required' }),
};
